import React, { Component } from 'react';
import { Button, TextField, CardContent, Typography, FormControlLabel, Switch, FormControl, InputLabel, Select, MenuItem, FormHelperText, FormGroup, Dialog, DialogTitle, DialogContent, Grid, DialogActions, Checkbox, FormLabel, RadioGroup, Radio } from '@material-ui/core';
import api from '../../../services/api';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { ANAO, ASIM, ATIPO_MODELO_RELATORIO_PARA_MAPA_DE_TRANSPORTE } from 'consts';
import { Book as BookIcon } from '@material-ui/icons';
import DicionarioDadosFornecedor from './DicionarioDadosFornecedor';
import { getConfigField } from 'lib/configUtils';
import { PhotoCamera, Description as DescriptionIcon } from '@material-ui/icons';

class MsgWhatsAppFornecedorForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mensagem: {},
            modelosrelatorio: [],
            arquivoPreview: null,
            downloadLink: null,
            isNewRecord: false,
            isView: false,
            openDictionaryModal: false,
        };
    };

    async componentDidMount() {
        // carrega informações formulário
        const { id } = this.props.match.params;
        const { location } = this.props;
        const currentPath = location.pathname;
        let arquivoPreview;
        let downloadLink = '';

        if (id >= 0) {
            const response = await api.get(`/whatsapp/mensagemfornecedor/${id}`);

            arquivoPreview = ((response.data[0].tipomensagem === 3) ? `data:image/${response.data[0].extensaoarquivo};base64,${response.data[0].arquivobase64}` : '');

            if (response.data[0].tipomensagem === 2) {
                const base64Data = response.data[0].arquivobase64;
                const extensao = response.data[0].extensaoarquivo;

                if (extensao === 'pdf') {
                    const pdfFile = new Blob([new Uint8Array(atob(base64Data).split("").map(char => char.charCodeAt(0)))], { type: 'application/pdf' });
                    downloadLink = URL.createObjectURL(pdfFile);
                }
            }

            if (response.data[0].recurso) {
                this.carregaModelosRelatorio(response.data[0].recurso);
            }

            this.setState({
                mensagem: response.data[0],
                arquivoPreview: arquivoPreview,
                downloadLink: downloadLink,
                isNewRecord: false,
                isView: (currentPath.includes('/view'))
            }
            );
        }
        else if (id === 'novo') {
            this.setState({
                isNewRecord: true
            });
        }
    }

    /* evento on change componentes */
    OnChange = (event) => {
        const { mensagem } = this.state;
        const { name, type, value, checked } = event.target;
        let adjustedValue = value;

        switch (type) {
            case 'checkbox':
                if (name === 'inativo') {
                    if (checked === false) {
                        adjustedValue = ASIM;
                    }
                    else {
                        adjustedValue = ANAO;
                    }
                } else {
                    if (checked === false) {
                        adjustedValue = ANAO;
                    } else {
                        adjustedValue = ASIM;
                    }
                }
                break;
            case 'textarea':
                break;
            case 'radio':
                adjustedValue = Number(value);
                break;
            default:
                if ((name === 'tipomensagem') || (name === 'recurso') || (name === 'codmodelorelatorio')) {
                    adjustedValue = Number(value);

                    if (name === 'tipomensagem') {
                        if (value === 2) {
                            mensagem.tipoarquivo = 1;
                        }
                    } else if (name === 'recurso') {
                        mensagem.codmodelorelatorio = 0;
                        this.carregaModelosRelatorio(value);
                    }
                } else if ((name === 'botao1') || (name === 'botao2')) {
                    //
                } else {
                    adjustedValue = value.toUpperCase();
                }
                break;
        }

        mensagem[name] = adjustedValue;
        this.setState({ mensagem: mensagem });
    };

    carregaModelosRelatorio = async (recurso) => {
        const modelosrelatorio = await api.get(`/modelorelatorio/active/true?tbmodelorelatorio.tipomodelo=${recurso}`);
        this.setState({ modelosrelatorio: modelosrelatorio.data });
    };

    onClickSave = () => {
        if (this.validationRequiredFields()) {
            if (this.state.isNewRecord) {
                this.insereMensagem()
            }
            else {
                this.atualizaMensagem();
            }
        }
    };

    onClickCancel = () => {
        this.props.history.push('/crm/msgwhatsappfornecedor');
    };

    validationRequiredFields() {
        const { mensagem } = this.state;
        let retorno = true;

        if ((String(mensagem.descricao).trim() === '') || (mensagem.descricao === undefined)) {
            mensagem.descricao = '';
            this.setState({ mensagem: mensagem });
            retorno = false;
        };

        if (!mensagem.tipomensagem || isNaN(mensagem.tipomensagem)) {
            mensagem.tipomensagem = '';
            this.setState({ mensagem });
            retorno = false;
        }

        this.setState({ mensagem });
        return retorno;
    };

    insereMensagem = async () => {
        const { mensagem } = this.state;
        mensagem.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));
        try {
            const response = await api.post(`/whatsapp/mensagemfornecedor`, mensagem);
            if (response.status === 200) {
                this.props.history.push('/crm/msgwhatsappfornecedor');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    atualizaMensagem = async () => {
        const { mensagem } = this.state;
        try {
            const response = await api.put(`/whatsapp/mensagemfornecedor/${mensagem.idmsgwhats}`, mensagem);
            if (response.status === 200) {
                this.props.history.push('/crm/msgwhatsappfornecedor');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    // Função para abrir o modal
    openDictionaryModal = () => {
        this.setState({ openDictionaryModal: true });
    };

    // Função para fechar o modal
    closeDictionaryModal = () => {
        this.setState({ openDictionaryModal: false });
    };

    handleImageUpload = (event) => {
        const { mensagem } = this.state;

        const file = event.target.files[0];
        if (!file) return;

        const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        const validPdfTypes = ['application/pdf'];

        const fileType = file.type;

        if (mensagem.tipomensagem === 2) {
            if (!(validPdfTypes.includes(fileType))) {
                this.handleOpenAlert('Por favor, selecione apenas arquivo PDF.');
                return;
            }
        } else if (mensagem.tipomensagem === 3) {
            if (!validImageTypes.includes(fileType)) {
                this.handleOpenAlert('Por favor, selecione apenas arquivo de imagem (JPEG/PNG).');
                return;
            }
        }

        const reader = new FileReader();

        reader.onloadend = () => {
            const caminho = file.webkitRelativePath || file.name;
            const nome = file.name;
            const extensao = nome.split('.').pop().toLowerCase();

            let arquivoPreview = null;
            let downloadLink = null;
            let arquivobase64 = null;

            if (validImageTypes.includes(fileType)) {
                arquivoPreview = reader.result;  // Para imagens, usamos o base64 para visualização
                arquivobase64 = reader.result.split(',')[1];  // Extrai o base64 da string Data URL
            } else if (validPdfTypes.includes(fileType)) {
                // Para PDFs, criamos um Blob a partir do ArrayBuffer e codificamos para base64
                const pdfFile = new Blob([reader.result], { type: 'application/pdf' });
                downloadLink = URL.createObjectURL(pdfFile);  // Link para o arquivo PDF
                // Converte o ArrayBuffer para base64
                arquivobase64 = this.arrayBufferToBase64(reader.result);
            }

            this.setState({
                mensagem: {
                    ...mensagem,
                    arquivobase64,  // Armazena o base64 do arquivo
                    caminhoearquivo: caminho,
                    nomearquivo: nome,
                    extensaoarquivo: extensao
                },
                arquivoPreview,
                downloadLink
            });
        };

        // Usamos readAsArrayBuffer para PDFs, para garantir que o conteúdo binário seja lido corretamente
        if (validPdfTypes.includes(fileType)) {
            reader.readAsArrayBuffer(file);  // Para PDFs, lemos como ArrayBuffer
        } else if (validImageTypes.includes(fileType)) {
            reader.readAsDataURL(file);  // Para imagens, lemos como base64
        }
    };

    // Função auxiliar para converter ArrayBuffer para base64 (para PDFs)
    arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);  // Codifica para base64
    };

    render() {
        const { mensagem, modelosrelatorio, arquivoPreview, downloadLink, openDictionaryModal } = this.state;
        const trabaceiterecebmsgwhatsapp = (getConfigField('trabaceiterecebmsgwhatsapp', 'cfg_crm') == ASIM);

        return (
            <div>
                <CardContent>
                    <Typography
                        component="h1"
                        variant="h3"
                    >
                        Mensagem {mensagem.idmsgwhats}
                    </Typography>

                    <br />

                    <TextField
                        label="Descrição"
                        name="descricao"
                        value={mensagem.descricao || ''}
                        variant="outlined"
                        onChange={this.OnChange}
                        helperText={mensagem.descricao === '' ? 'Descrição obrigatória' : ' '}
                        disabled={this.state.isView}
                        inputProps={{ maxLength: 100 }}
                        fullWidth
                    />

                    <FormControlLabel
                        control={
                            <Switch
                                checked={!(mensagem.inativo === ASIM)}
                                name={"inativo"}
                                onChange={this.OnChange}
                                color="primary"
                                disabled={this.state.isView}
                            />
                        }
                        label={(mensagem.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                    />

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        rowGap: '10px', // espaço entre linhas (opcional)
                        columnGap: '15px', // espaço entre colunas (opcional)
                        marginTop: 10
                    }}>
                        <FormControl
                            variant="outlined"
                            style={{ marginTop: 16, width: 200 }}
                            disabled={this.state.isView}
                        >
                            <InputLabel id="tipo-mensagem-label">Tipo mensagem</InputLabel>
                            <Select
                                labelId="tipo-mensagem-label"
                                name="tipomensagem"
                                value={mensagem.tipomensagem || ''}
                                onChange={this.OnChange}
                                label="Tipo mensagem"
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    },
                                    getContentAnchorEl: null,
                                }}
                            >
                                <MenuItem value={1}>Mensagem texto</MenuItem>
                                <MenuItem value={2}>Documento</MenuItem>
                                <MenuItem value={3}>Imagem</MenuItem>
                                <MenuItem value={4}>Lista de botões</MenuItem>
                            </Select>
                            <FormHelperText>
                                {mensagem.tipomensagem === '' ? 'Tipo de mensagem obrigatório' : ' '}
                            </FormHelperText>
                        </FormControl>

                        {(mensagem.tipomensagem === 1 || mensagem.tipomensagem === 4) && (
                            <Button
                                variant="contained"
                                color="default"
                                style={{ backgroundColor: '#e0e0e0' }}
                                disabled={this.state.isView}
                                startIcon={<BookIcon />}
                                onClick={this.openDictionaryModal}
                            >
                                Dicionário
                            </Button>)
                        }

                        {mensagem.tipomensagem === 2 && (
                            <FormControl
                                disabled={this.state.isView}
                                style={{}}
                            >
                                <FormLabel>Tipo arquivo</FormLabel>
                                <RadioGroup
                                    row
                                    name="tipoarquivo"
                                    value={mensagem.tipoarquivo || ''}
                                    onChange={this.OnChange}
                                >
                                    <FormControlLabel value={1} control={<Radio />} label="Fixo" />
                                    <FormControlLabel value={2} control={<Radio />} label="Dinâmico" />
                                </RadioGroup>
                            </FormControl>
                        )}

                        {((mensagem.tipomensagem === 2 && mensagem.tipoarquivo === 1) || (mensagem.tipomensagem === 3)) && (
                            <FormGroup>
                                <input
                                    accept={
                                        mensagem.tipomensagem === 3
                                            ? 'image/*'
                                            : mensagem.tipomensagem === 2
                                                ? '.pdf'
                                                : ''
                                    }
                                    type="file"
                                    id="upload-button-file"
                                    style={{ display: 'none' }}
                                    onChange={this.handleImageUpload}
                                    disabled={this.state.isView}
                                />

                                <label htmlFor="upload-button-file">
                                    <Button
                                        variant="contained"
                                        component="span"
                                        startIcon={
                                            mensagem.tipomensagem === 2 ? <DescriptionIcon /> : <PhotoCamera />
                                        }
                                        disabled={this.state.isView}
                                        style={{ backgroundColor: '#e0e0e0' }}
                                    >
                                        {mensagem.tipomensagem === 2 ? 'Escolher Arquivo' : 'Escolher Imagem'}
                                    </Button>
                                </label>
                            </FormGroup>
                        )}

                        {(mensagem.tipomensagem === 2 && mensagem.tipoarquivo === 1) && (downloadLink) && (
                            <div>
                                <a
                                    href={downloadLink}
                                    download={mensagem.nomearquivo}
                                    style={{
                                        display: 'inline-block',
                                        padding: '8px 12px',
                                        backgroundColor: '#007bff',
                                        color: '#fff',
                                        textDecoration: 'none',
                                        borderRadius: '4px',
                                        fontSize: '14px'
                                    }}
                                >
                                    {mensagem.nomearquivo}
                                </a>
                            </div>
                        )}

                        {(mensagem.tipomensagem === 2 && mensagem.tipoarquivo === 2) && (
                            <FormControl
                                variant="outlined"
                                style={{ width: 200 }}
                                disabled={this.state.isView}
                            >
                                <InputLabel id="recurso-label">Recurso</InputLabel>
                                <Select
                                    labelId="recurso-label"
                                    name="recurso"
                                    value={mensagem.recurso || ''}
                                    onChange={this.OnChange}
                                    label="Recurso"
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        },
                                        transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'left',
                                        },
                                        getContentAnchorEl: null,
                                    }}
                                >
                                    <MenuItem value={ATIPO_MODELO_RELATORIO_PARA_MAPA_DE_TRANSPORTE}>Mapa de transporte</MenuItem>
                                </Select>
                            </FormControl>
                        )}

                        {(mensagem.tipomensagem === 2 && mensagem.tipoarquivo === 2) && (
                            <FormControl
                                variant="outlined"
                                style={{ width: 400 }}
                                disabled={this.state.isView}
                            >
                                <InputLabel id="modelo-relatorio-label">Modelo de relatório</InputLabel>
                                <Select
                                    labelId="modelo-relatorio-label"
                                    name="codmodelorelatorio"
                                    value={mensagem.codmodelorelatorio || ''}
                                    onChange={this.OnChange}
                                    label="Modelo de relatório"
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        },
                                        transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'left',
                                        },
                                        getContentAnchorEl: null,
                                    }}
                                >
                                    {modelosrelatorio.map((modelo) => (
                                        <MenuItem value={modelo.codigo}>{modelo.nome}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    </div>

                    <br />

                    <FormGroup>
                        {(mensagem.tipomensagem === 1 || mensagem.tipomensagem === 4) && (
                            <textarea
                                id="msg"
                                name="msg"
                                onChange={this.OnChange}
                                style={{ height: '150px' }}
                                type="textarea"
                                value={mensagem.msg}
                                disabled={this.state.isView}
                            />)
                        }

                        {/* <br /> */}

                        {(mensagem.tipomensagem === 4) && (
                            <FormGroup row style={{ gap: 10, marginTop: 10 }}>
                                <TextField
                                    label="Botão 1 (Aceitar)"
                                    name="botao1"
                                    value={mensagem.botao1 || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    inputProps={{ maxLength: 20 }}
                                    style={{ width: 150 }}
                                />

                                <TextField
                                    label="Botão 2 (Recusar)"
                                    name="botao2"
                                    value={mensagem.botao2 || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    inputProps={{ maxLength: 20 }}
                                    style={{ width: 150 }}
                                />

                                {trabaceiterecebmsgwhatsapp && (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={(mensagem.mensagemconfirmacaorecebimento === ASIM)}
                                                name="mensagemconfirmacaorecebimento"
                                                onChange={this.OnChange}
                                                color="primary"
                                                disabled={this.state.isView}
                                            />}
                                        label={'Mensagem para confirmar se fornecedor deseja receber mensagens'}
                                    />)
                                }
                            </FormGroup>)
                        }

                        {(mensagem.tipomensagem === 3) && (
                            <FormGroup>
                                {arquivoPreview && (
                                    <div>
                                        <img
                                            src={arquivoPreview}
                                            alt="Pré-visualização"
                                            style={{
                                                maxHeight: '300px',
                                                width: 'auto',
                                                height: 'auto',
                                                maxWidth: '100%',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px'
                                            }}
                                        />

                                        <Typography variant="body2" style={{}}>
                                            {mensagem.nomearquivo}
                                        </Typography>
                                    </div>
                                )}
                            </FormGroup>
                        )}
                    </FormGroup>

                    <br />
                    <br />

                    <Button
                        name="salvar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickSave}
                        style={{ marginTop: '10px' }}
                        disabled={this.state.isView}
                    >
                        Salvar
                    </Button>

                    <Button
                        name="cancelar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickCancel}
                        style={{ marginTop: '10px', marginLeft: '10px' }}
                    >
                        Cancelar
                    </Button>
                </CardContent >

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />

                {/* Modal "Dicionário" */}
                <Dialog
                    open={openDictionaryModal}
                    onClose={this.closeDictionaryModal}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>Dicionário de dados</DialogTitle>
                    <DialogContent>
                        <DicionarioDadosFornecedor>
                        </DicionarioDadosFornecedor>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeDictionaryModal} color="primary">
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div >
        );
    }
}

export default MsgWhatsAppFornecedorForm;